import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Team() {
  const [selectedDoctor, setSelectedDoctor] = useState<number | null>(null);
  const navigate = useNavigate();

  const teamMembers = [
    {
      id: 1,
      name: "Dr. John Peterson",
      title: "Founder & Senior Insurance Doctor",
      specialty: "Auto & Home Insurance Specialist",
      experience: "25+ Years",
      image: "https://static.readdy.ai/image/7c34e572229199a03c653ba249394690/db1af4aa0868dd8f7865b0f8b762d1f3.jfif",
      bio: "John Peterson is a trusted Farmers Insurance agent and the founder of The Insurance Doctors. With over 25 years of experience, he specializes in diagnosing coverage gaps and prescribing tailored insurance solutions for individuals, families, and businesses.",
      credentials: ["Farmers Insurance Licensed Agent", "Financial Services Background", "Business Insurance Specialist"],
      phone: "(949) 951-8119",
      email: "john@theinsurancedoctors.com"
    },
    {
      id: 2,
      name: "Dr. Milissa Kolstad",
      title: "Lead Insurance Nurse",
      specialty: "Patient Care & Insurance Navigation",
      experience: "18+ Years",
      image: "https://public.readdy.ai/ai/img_res/faa10ff1a679dad46d2009dec943967f.jpg",
      bio: "Dr. Milissa Kolstad serves as our Lead Insurance Nurse, bringing nearly two decades of expertise in patient care and insurance navigation. She specializes in helping patients understand their coverage options and guides them through the insurance process with compassion and expertise.",
      credentials: ["Certified Insurance Navigator", "Patient Care Specialist", "Coverage Counseling Expert"],
      phone: "(949) 334-5808",
      email: "milissa@theinsurancedoctors.com"
    },
    {
      id: 3,
      name: "Dr. Jack Peterson Sr.",
      title: "Business Insurance Specialist",
      specialty: "Commercial & Business Protection",
      experience: "22+ Years",
      image: "https://readdy.ai/api/search-image?query=Professional%20senior%20male%20business%20insurance%20specialist%20in%20navy%20business%20suit%2C%20confident%20professional%20smile%2C%20modern%20office%20background%2C%20business%20headshot%2C%20professional%20lighting%2C%20experienced%20businessman%20with%20gray%20hair&width=400&height=500&seq=jack-peterson-sr&orientation=portrait",
      bio: "Dr. Jack Peterson Sr. specializes in protecting businesses of all sizes. From small startups to large corporations, he diagnoses business risks and prescribes comprehensive commercial insurance solutions.",
      credentials: ["Commercial Insurance Expert", "Risk Management Specialist", "Business Continuity Advisor"],
      phone: "(949) 951-8121",
      email: "jack@theinsurancedoctors.com"
    },
    {
      id: 4,
      name: "Dr. Emily Johnson",
      title: "Auto Insurance Specialist",
      specialty: "Vehicle & Transportation Coverage",
      experience: "15+ Years",
      image: "https://readdy.ai/api/search-image?query=Professional%20blonde%20female%20insurance%20agent%20in%20light%20blue%20business%20blazer%2C%20friendly%20professional%20smile%2C%20modern%20office%20setting%2C%20business%20headshot%2C%20natural%20lighting%2C%20approachable%20business%20woman&width=400&height=500&seq=emily-johnson&orientation=portrait",
      bio: "Dr. Emily Johnson is our auto insurance expert, helping drivers find the perfect coverage for their vehicles and driving needs. She specializes in high-risk drivers and specialty vehicle coverage.",
      credentials: ["Auto Insurance Certified Specialist", "High-Risk Driver Expert", "Fleet Insurance Advisor"],
      phone: "(949) 951-8122",
      email: "emily@theinsurancedoctors.com"
    },
    {
      id: 5,
      name: "Dr. Robert Thompson",
      title: "Senior Claims Specialist",
      specialty: "Claims Processing & Resolution",
      experience: "20+ Years",
      image: "https://readdy.ai/api/search-image?query=Professional%20senior%20male%20insurance%20claims%20specialist%20in%20dark%20gray%20business%20suit%2C%20experienced%20professional%20smile%2C%20office%20background%2C%20business%20headshot%2C%20professional%20lighting%2C%20mature%20businessman%20with%20gray%20hair&width=400&height=500&seq=robert-thompson&orientation=portrait",
      bio: "Dr. Robert Thompson leads our claims department with two decades of experience in claims processing and resolution. He ensures our patients receive fast, fair claim settlements when they need them most.",
      credentials: ["Certified Claims Specialist", "Litigation Support Expert", "Customer Advocacy Specialist"],
      phone: "(949) 951-8123",
      email: "robert@theinsurancedoctors.com"
    },
    {
      id: 6,
      name: "Dr. Lisa Park",
      title: "Property Insurance Doctor",
      specialty: "Home & Property Protection",
      experience: "16+ Years",
      image: "https://readdy.ai/api/search-image?query=Professional%20korean%20female%20insurance%20agent%20in%20burgundy%20business%20blazer%2C%20confident%20warm%20smile%2C%20modern%20office%20background%2C%20business%20headshot%2C%20professional%20lighting%2C%20friendly%20business%20woman&width=400&height=500&seq=lisa-park&orientation=portrait",
      bio: "Dr. Lisa Park specializes in protecting homes and properties. She helps homeowners understand their coverage needs and ensures they have adequate protection for their most valuable assets.",
      credentials: ["Property Insurance Expert", "Homeowner Specialist", "Flood Insurance Certified"],
      phone: "(949) 951-8124",
      email: "lisa@theinsurancedoctors.com"
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Home Button */}
      <button
        onClick={() => navigate('/')}
        className="fixed top-6 right-6 z-50 bg-blue-600 hover:bg-blue-700 text-white p-3 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 cursor-pointer"
        title="Go to Home"
      >
        <i className="ri-home-line text-xl w-6 h-6 flex items-center justify-center"></i>
      </button>

      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-br from-blue-900 via-blue-800 to-indigo-900">
        <div 
          className="absolute inset-0"
          style={{
            backgroundImage: `url('https://readdy.ai/api/search-image?query=Modern%20professional%20insurance%20office%20interior%20with%20team%20of%20diverse%20professionals%2C%20bright%20lighting%2C%20contemporary%20business%20environment%2C%20professional%20medical-style%20office%20setting%2C%20clean%20modern%20design%2C%20team%20collaboration%20space&width=1920&height=600&seq=team-hero-bg&orientation=landscape')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat'
          }}
        >
          <div className="absolute inset-0 bg-blue-900/80"></div>
        </div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
            Meet Your Insurance Doctors
          </h1>
          <p className="text-xl md:text-2xl text-blue-100 max-w-4xl mx-auto leading-relaxed">
            Our team of licensed insurance professionals brings decades of combined experience to diagnose your coverage needs and prescribe the perfect protection plan.
          </p>
          <div className="mt-8 flex justify-center space-x-8">
            <div className="text-center">
              <div className="text-3xl font-bold text-white">120+</div>
              <div className="text-blue-200">Years Combined Experience</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-white">15,000+</div>
              <div className="text-blue-200">Patients Served</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-white">6</div>
              <div className="text-blue-200">Insurance Specialists</div>
            </div>
          </div>
        </div>
      </section>

      {/* Team Grid */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              Our Insurance Medical Team
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Each of our insurance doctors specializes in specific areas of coverage, ensuring you receive expert care for all your protection needs.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {teamMembers.map((member) => (
              <div 
                key={member.id}
                className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden group cursor-pointer"
                onClick={() => setSelectedDoctor(selectedDoctor === member.id ? null : member.id)}
              >
                <div className="relative">
                  <img 
                    src={member.image}
                    alt={member.name}
                    className="w-full h-80 object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-4 right-4 bg-blue-600 text-white px-3 py-1 rounded-full text-sm font-semibold">
                    {member.experience}
                  </div>
                </div>
                
                <div className="p-6">
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">{member.name}</h3>
                  <div className="text-blue-600 font-semibold mb-2">{member.title}</div>
                  <div className="text-gray-600 mb-4">{member.specialty}</div>
                  
                  <div className="flex items-center justify-between">
                    <div className="flex space-x-2">
                      <a 
                        href={`tel:${member.phone}`}
                        className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center hover:bg-blue-600 hover:text-white transition-colors cursor-pointer"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <i className="ri-phone-line"></i>
                      </a>
                      <a 
                        href={`mailto:${member.email}`}
                        className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center hover:bg-blue-600 hover:text-white transition-colors cursor-pointer"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <i className="ri-mail-line"></i>
                      </a>
                    </div>
                    
                    <button className="text-blue-600 hover:text-blue-800 font-semibold flex items-center whitespace-nowrap">
                      {selectedDoctor === member.id ? 'Less Info' : 'Learn More'}
                      <i className={`ri-arrow-${selectedDoctor === member.id ? 'up' : 'down'}-s-line ml-1`}></i>
                    </button>
                  </div>
                  
                  {selectedDoctor === member.id && (
                    <div className="mt-6 pt-6 border-t border-gray-200 animate-fade-in-up">
                      <p className="text-gray-600 mb-4 leading-relaxed">{member.bio}</p>
                      
                      <div className="mb-4">
                        <h4 className="font-semibold text-gray-900 mb-2">Credentials & Specialties:</h4>
                        <div className="space-y-1">
                          {member.credentials.map((credential, index) => (
                            <div key={index} className="flex items-center text-sm text-gray-600">
                              <i className="ri-check-line text-green-600 mr-2"></i>
                              {credential}
                            </div>
                          ))}
                        </div>
                      </div>
                      
                      <div className="grid grid-cols-1 gap-2 text-sm">
                        <div className="flex items-center text-gray-600">
                          <i className="ri-phone-line text-blue-600 mr-2"></i>
                          {member.phone}
                        </div>
                        <div className="flex items-center text-gray-600">
                          <i className="ri-mail-line text-blue-600 mr-2"></i>
                          {member.email}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-16 bg-blue-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">
            Ready to Meet Your Insurance Doctor?
          </h2>
          <p className="text-xl text-gray-600 mb-8">
            Schedule a consultation with one of our insurance specialists to get a personalized diagnosis of your coverage needs.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-all duration-300 hover:scale-105 hover:shadow-xl whitespace-nowrap cursor-pointer">
              Schedule Team Consultation
            </button>
            <button className="bg-white hover:bg-gray-50 text-blue-600 border-2 border-blue-600 px-8 py-4 rounded-lg text-lg font-semibold transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer">
              Call (949) 951-8119
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}
